import * as Yup from 'yup';

import i18n from '@/i18n';

export const liveStreamSchema = Yup.object().shape({
  email: Yup.string().email(i18n.t('emailInvalid', { ns: 'common' }))
});

export const liveStreamDescriptionSchema = Yup.object().shape({
  description: Yup.string()
    .required(i18n.t('descriptionRequired', { ns: 'common' }))
    .max(80, i18n.t('waitingScreenDescriptionMax', { ns: 'common' }))
});

export const recordingDateSchema = Yup.object().shape({
  recordingDate: Yup.string()
});
